import { HisUiService } from './../../../core/service/base/his-ui.service';
import { HisDynamicContainerComponent } from './dynamic-container.component';
import { Component, ViewChild, ChangeDetectorRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { HisDynamicFieldBase } from '../../model/field-base';
import { HisDynamicFieldConfig } from '../../model/formfield';
import { HisDynamicFieldConfigAndData } from '../../model/field-config-and-data';
import { HisBaseGlobalsService } from '../../../core/service/base/his-base-globals.service';
import { UntypedFormGroup } from '@angular/forms';

@Component( {
    template: `
        @if (isFieldSetVisible) {
          <p-panel header="{{ label }}" [hisDdKey]="config.ddKey">
            <his-dynamic-container (readyToUse)="containerDone()" [dynamicFieldConfig]="config"></his-dynamic-container>
          </p-panel>
        }
        `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
} )
export class FieldsetComponent extends HisDynamicFieldBase<string> {
    private hbgs: HisBaseGlobalsService;
    private changeDetectorRef = inject(ChangeDetectorRef);

    @ViewChild( HisDynamicContainerComponent )
        dynamicContainerComponent: HisDynamicContainerComponent;
    config: HisDynamicFieldConfig;
    label = '';
    localFormGroup: UntypedFormGroup;
    isFieldSetVisible: boolean;

    constructor() {
        const injectedData = inject<HisDynamicFieldConfigAndData>('injectedData' as any);
        const hbgs = inject(HisBaseGlobalsService);
        const hisUi = inject(HisUiService);

        super( injectedData.formGroup, injectedData.options, injectedData.valueGroup, hbgs );
        this.hbgs = hbgs;

        this.config = injectedData.options;
        this.label = hisUi.translate( this.config.label ).replace( /\?\?\?/g, '' );
        this.setPanelVisibilty();
    }

    containerDone() {
        this.changeDetectorRef.detectChanges();
        this.localFormGroup = this.dynamicContainerComponent.form;
        this.formGroup.registerControl( this.name, this.localFormGroup );
        this.valueGroup.registerDynamicField( this, this.localFormGroup.valueChanges );
    }

    reset() {
        this.dynamicContainerComponent.resetDynamicForm();
    }

    updateConfiguration( entireFormConfig: HisDynamicFieldConfig ): void {
        this.setPanelVisibilty();
        this.dynamicContainerComponent.updateConfiguration( entireFormConfig );
    }

    getControlValue(): any {
        return this.dynamicContainerComponent.getJson();
    }

    setPanelVisibilty() {
        // check if p-panel has at least one visible child element
        let atLeastOneChildVisible: HisDynamicFieldConfig[] = this.config.children.filter( ( child: HisDynamicFieldConfig ) => {
            let dDEntry = this.hbgs.getDd( child.ddKey );
            console.log( 'HisDynamicFieldConfig has existing data dictionary entry: ', dDEntry );
            return dDEntry == null || !dDEntry.hidden;
        } );
        this.isFieldSetVisible = atLeastOneChildVisible.length > 0 ? true : false;
    }
}
